import { formatDate } from '@/helper'

export default {
  getData (state) {
    return state.data.map((item) => {
      return {
        ...item,
        createdAtFormatted: formatDate(item.createdAt)
      }
    })
  }
}